import { config } from "../shared/config"

export interface ParentConfig {
  tag: "portal"
}

export const getTokenFromParent = (): Promise<string | null> =>
  new Promise<string | null>((resolve) => {
    const listener = (event: MessageEvent): void => {
      if (event.data?.type !== `SEND_AUTH_TOKEN`) return

      if (!config().isAllowedOrigin(event.origin)) {
        console.warn(`Ignoring SEND_AUTH_TOKEN postMessage from disallowed origin: ${event.origin}`)
        return
      }

      const { token } = event.data
      if (token !== undefined) {
        window.removeEventListener(`message`, listener, false)
        resolve(token)
        return
      }
      resolve(null)
    }

    window.addEventListener(`message`, listener, false)
    window.parent.postMessage({ type: `REQUEST_AUTH_TOKEN` }, `*`)
  })
